<template>
  <div class="container-fluid">
    <span class="resize-loading" v-if="!label">
      <span class="loader"></span>
    </span>
    <label-form
      v-if="label"
      :loading="loading"
      :labelData="label"
      :formErrors="formErrors"
      @labelSubmitted="handleSubmit"
      @formChanged="() => (alertLeave = true)"
    />
  </div>
</template>

<script>
import { cloneDeep } from "lodash";
import alertLeave from "@/mixins/alert-leave-mixin";
import LabelForm from "../partials/LabelForm.vue";

export default {
  layout: "DashboardLayout",

  components: { LabelForm },

  mixins: [alertLeave],

  props: {
    labelId: {
      type: [String, Number],
      required: true,
    },
  },

  data() {
    return {
      label: null,
      formErrors: null,
      loading: false,
    };
  },

  created() {
    this.get();
  },

  methods: {
    async get() {
      this.loading = true;
      try {
        await this.$store.dispatch("labels/get", this.labelId);
        this.label = this.$store.getters["labels/label"];
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.loading = false;
      }
    },

    async handleSubmit(label) {
      this.loading = true;
      let labelData = cloneDeep(label);

      try {
        await this.$store.dispatch("labels/update", labelData);
        this.$notify({
          type: "success",
          message: this.$t("LABELS.LABEL_UPDATED"),
        });
        const label = this.$store.getters["labels/label"];
        this.$emit("onViewLabel", label, true);
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        this.loading = false;
      }
    },
  },
};
</script>
